<template lang='pug' src='./hero-home.pug'></template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import FunctionButton from 'components/block/block-function-button/block-function-button'

export default {
  props: ['props'],
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 5000
        },
        speed: 1000,
        loop: true
      }
    }
  },
  methods: {
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  },
  components: {
    FunctionButton,
    swiper,
    swiperSlide
  }
}
</script>



// WEBPACK FOOTER //
// hero-home.vue?2fb160a2